module.exports = __webpack_public_path__ + "img/13.c36c7c67.png";